import React, { useState } from "react";
import "../games/addgames.css";
import Index from "../../../Index";
import PagesIndex from "../../../PagesIndex";
import "../lockperiod/addlockperiod.css";
import { useAccount } from "wagmi";
import {  ethers } from "ethers";
import { useEthersSigner } from "../../../../Connectivity/WalletSignerprovider";
import { DugoutObj } from "../../../../Connectivity/ContractObject";



function EditLockPeriod() {
  const { state } = PagesIndex.useLocation();
  const navigate = PagesIndex.useNavigate();
  const signer = useEthersSigner();
  const [loading, setLoading] = useState(false);
  const account = useAccount();
  const dayData = PagesIndex.useSelector((state) => state.admin.lockList);
  const [existingDay, setExistingDay] = useState(
    dayData.map((item) => item.day)
  );
  const [fieldErrors, setFieldErrors] = useState("");
  const [newDayFieldErrors, setNewDayFieldErrors] = useState("");
  let initialValues = {
    LockDay: state?.item ? state?.item?.day : "",
    newLockDay:0,
    LockRate: state?.item ? state?.item?.apyrate : "",
    LockAmount: state?.item ? state?.item?.maximumStakingAmount : "",
    description: state?.item ? state?.item?.description : "",
    stakeFees: state?.item ? state?.item?.EarlyUnstakeFees : "",
    stakeSpn: state?.item ? state?.item?.stakeSpn : "",
    title: state?.item ? state?.item?.title : "",
  };

  const addEditLockCall = (urlEncoded) => {
    PagesIndex.DataService.post(PagesIndex.Api.ADD_EDIT_LOCK_PERIOD, urlEncoded)
      .then((res) => {
        if (res?.status === 200) {
          PagesIndex.toast.success(res.data.message);
          navigate("/admin/lock-period");
        }
      })
      .catch((err) => {
        setLoading(false)
        PagesIndex.toast.error(err?.response?.data?.message);
      });
  };

  const updateLockDay = async (
    existingDays,
    newLockTime,
    apyRate,
    maxmumStakingAmount,
    earlyUnstakeFees,
    urlEncoded
  ) => {
    try {
      const dugout = await DugoutObj(signer);
      const maxmumstaking = ethers.utils.parseEther(
        maxmumStakingAmount.toString()
      );
      let updatelockday = await dugout.changeLockTime(
        existingDays,
        newLockTime,
        apyRate,
        maxmumstaking,
        earlyUnstakeFees
      );
      addEditLockCall(urlEncoded);
    } catch (error) {
      setLoading(false)
      if (error?.error?.data?.message != undefined) {
        const err=error?.error?.data?.message?.split(":")
        PagesIndex.toast.error(err[err?.length - 1]);
      }
    }
  };

  const handleLockEditForm = async (values) => {
    setLoading(true)
    if (account?.address) {
      const urlEncoded = new URLSearchParams();
      urlEncoded.append(
        "day",
        values?.newLockDay ? values?.newLockDay : values?.LockDay
      );
      urlEncoded.append("stakeSpn", values?.stakeSpn);
      urlEncoded.append("apyrate", values?.LockRate);
      urlEncoded.append("maximumStakingAmount", values?.LockAmount);
      urlEncoded.append("title", values?.title);
      urlEncoded.append("description", values?.description);
      urlEncoded.append("EarlyUnstakeFees", values?.stakeFees);
      if (state?.item?._id) {
        urlEncoded.append("id", state?.item?._id);
      }
      await updateLockDay(
        values?.LockDay,
        values?.newLockDay,
        values?.LockRate,
        values?.LockAmount,
        values?.stakeFees,

        urlEncoded
      );
    } else {
      setLoading(false)
      connectionAlert();
    }
  };

  const connectionAlert = () => {
    PagesIndex.toast.error("Please connect Metamask");
  };
  return (
    <>
      <Index.Box className="add-games-main add-lock-period-main">
        <Index.Box className="main-title">
          <Index.Typography className="head-title" component="h1">
            Update Lock Period
          </Index.Typography>
          <Index.Box className="header-button-box">
            <Index.Link to="/admin/lock-period" className="cus-link-btn">
              <Index.PrimaryButton
                btnLabel="Back"
                className="primary-btn add-game-btn"
              />
            </Index.Link>
          </Index.Box>
        </Index.Box>
        {loading ? (<>
          <Index.loader />
               </>):(
        <Index.Box className="game-upload-wrapper">
          <PagesIndex.Formik
            enableReinitialize
            onSubmit={handleLockEditForm}
            initialValues={initialValues}
            validationSchema={PagesIndex.validationSchemaLockEdit}
          >
            {({
              values,
              errors,
              touched,
              handleChange,
              handleBlur,
              handleSubmit,
              setFieldTouched,
              setFieldValue,
              resetForm,
              setFieldError,
            }) => (
              <Index.Box
                className="game-upload-body"
                component="form"
                onSubmit={handleSubmit}
              >
                {/* {console.log("error", errors)} */}
                {/* {console.log("values", values)} */}

                <Index.Box className="game-flex">
                  <Index.Box className="game-upload-name">
                    <Index.Box className="admin-dashboad-row">
                      <Index.Box sx={{ width: 1 }} className="grid-main">
                        <Index.Box
                          display="grid"
                          className="display-row"
                          gridTemplateColumns="repeat(12, 1fr)"
                          gap={{ xs: 2, sm: 2, md: 0, lg: 0 }}
                        >
                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 6",
                              md: "span 6",
                              lg: "span 6",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="input-box">
                              <Index.FormHelperText className="game-title">
                                New Lock Days
                              </Index.FormHelperText>
                              <Index.Box className="form-group">
                                <Index.TextField
                                  fullWidth
                                  id="newLockDay"
                                  name="newLockDay"
                                  type="string"
                                  onChange={(e) => {
                                    const inputValue = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (inputValue !== "0") {
                                      setFieldValue(
                                        "newLockDay",
                                        inputValue.slice(0, 3)
                                      );
                                      if (existingDay.includes(inputValue)) {
                                        setNewDayFieldErrors(
                                          " This days already exists"
                                        );
                                      } else {
                                        setNewDayFieldErrors("");
                                      }
                                    }
                                  }}
                                  className="form-control"
                                />
                                <Index.FormHelperText
                                  error
                                  className="error-text"
                                >
                                  {newDayFieldErrors ? newDayFieldErrors : null}
                                </Index.FormHelperText>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 6",
                              md: "span 6",
                              lg: "span 6",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="input-box">
                              <Index.FormHelperText className="game-title">
                                Stake SPN
                              </Index.FormHelperText>
                              <Index.Box className="form-group">
                                <Index.TextField
                                  fullWidth
                                  id="stakeSpn"
                                  name="stakeSpn"
                                  onChange={(e) => {
                                    const inputValue = e?.target?.value?.replace(/[^A-Za-z ]/g, '');
                                    setFieldValue("stakeSpn", inputValue);
                                  }}
                                  // onChange={handleChange}
                                  value={values?.stakeSpn}
                                  onBlur={handleBlur}
                                  className="form-control"
                                  InputProps={{
                                    inputProps: {
                                      maxLength: 32,
                                    },
                                  }}
                                />
                                <Index.FormHelperText
                                  error
                                  className="error-text"
                                >
                                  {errors.stakeSpn && touched.stakeSpn
                                    ? errors.stakeSpn
                                    : null}
                                </Index.FormHelperText>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>

                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 6",
                              md: "span 6",
                              lg: "span 6",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="input-box">
                              <Index.FormHelperText className="game-title">
                                Existing Days
                              </Index.FormHelperText>

                              <Index.Box className="form-group">
                                <Index.TextField
                                  fullWidth
                                  id="LockDay"
                                  name="LockDay"
                                  type="string"
                                  onChange={(e) => {
                                    const inputValue = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (inputValue !== "0") {
                                      setFieldValue(
                                        "LockDay",
                                        inputValue.slice(0, 3)
                                      );
                                      if (existingDay.includes(inputValue)) {
                                        setFieldErrors(
                                          " This days already exists"
                                        );
                                      } else {
                                        setFieldErrors("");
                                      }
                                    }
                                  }}
                                  value={values?.LockDay}
                                  onBlur={handleBlur}
                                  className="form-control"
                                />
                                <Index.FormHelperText
                                  error
                                  className="error-text"
                                >
                                  {errors.LockDay && touched.LockDay
                                    ? errors.LockDay
                                    : null}
                                  {fieldErrors ? fieldErrors : null}
                                </Index.FormHelperText>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>

                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 6",
                              md: "span 6",
                              lg: "span 6",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="input-box">
                              <Index.FormHelperText className="game-title">
                                APY rate<span> (%)</span>
                              </Index.FormHelperText>
                              <Index.Box className="form-group">
                                <Index.TextField
                                  fullWidth
                                  id="LockRate"
                                  name="LockRate"
                                  type="string"
                                  value={values?.LockRate}
                                  onChange={(e) => {
                                    const inputValue = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (
                                      inputValue !== "0" &&
                                      Number(inputValue) < 101
                                    ) {
                                      setFieldValue(
                                        "LockRate",
                                        inputValue.slice(0, 3)
                                      );
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  className="form-control"
                                />
                                <Index.FormHelperText
                                  error
                                  className="error-text"
                                >
                                  {errors.LockRate && touched.LockRate
                                    ? errors.LockRate
                                    : null}
                                </Index.FormHelperText>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 6",
                              md: "span 6",
                              lg: "span 6",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="input-box">
                              <Index.FormHelperText className="game-title">
                                Early Unstake Fees<span> (%)</span>
                              </Index.FormHelperText>
                              <Index.Box className="form-group">
                                <Index.TextField
                                  fullWidth
                                  id="stakeFees"
                                  name="stakeFees"
                                  className="form-control"
                                  type="string"
                                  onChange={(e) => {
                                    const inputValue = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (inputValue !== "0") {
                                      setFieldValue(
                                        "stakeFees",
                                        inputValue.slice(0, 10)
                                      );
                                    }
                                  }}
                                  onBlur={handleBlur}
                                  value={values?.stakeFees}
                                />
                                <Index.FormHelperText
                                  error
                                  className="error-text"
                                >
                                  {errors.stakeFees && touched.stakeFees
                                    ? errors.stakeFees
                                    : null}
                                </Index.FormHelperText>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                          <Index.Box
                            gridColumn={{
                              xs: "span 12",
                              sm: "span 6",
                              md: "span 6",
                              lg: "span 6",
                            }}
                            className="grid-column"
                          >
                            <Index.Box className="input-box">
                              <Index.FormHelperText className="game-title">
                                Maximum Staking Amount
                              </Index.FormHelperText>
                              <Index.Box className="form-group">
                                <Index.TextField
                                  fullWidth
                                  id="LockAmount"
                                  name="LockAmount"
                                  type="string"
                                  onChange={(e) => {
                                    const inputValue = e.target.value.replace(
                                      /\D/g,
                                      ""
                                    );
                                    if (inputValue !== "0") {
                                      setFieldValue(
                                        "LockAmount",
                                        inputValue.slice(0, 10)
                                      );
                                    }
                                  }}
                                  value={values?.LockAmount}
                                  onBlur={handleBlur}
                                  className="form-control"
                                />
                                <Index.FormHelperText
                                  error
                                  className="error-text"
                                >
                                  {errors.LockAmount && touched.LockAmount
                                    ? errors.LockAmount
                                    : null}
                                </Index.FormHelperText>
                              </Index.Box>
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                        <Index.Box
                          gridColumn={{
                            xs: "span 12",
                            sm: "span 12",
                            md: "span 12",
                            lg: "span 12",
                          }}
                          className="grid-column"
                        >
                          <Index.Box className="input-box">
                            <Index.FormHelperText className="game-title">
                              Title
                            </Index.FormHelperText>
                            <Index.Box className="form-group">
                              <Index.TextField
                                fullWidth
                                id="title"
                                name="title"
                                // onChange={handleChange}
                                onChange={(e) => {
                                  const inputValue = e?.target?.value?.replace(/[^A-Za-z ]/g, ''); 
                                  setFieldValue("title", inputValue);
                                }}
                                onBlur={handleBlur}
                                value={values?.title}
                                className="form-control"
                                InputProps={{
                                  inputProps: {
                                    maxLength: 100,
                                  },
                                }}
                              />
                              <Index.FormHelperText
                                error
                                className="error-text"
                              >
                                {errors.title && touched.title
                                  ? errors.title
                                  : null}
                              </Index.FormHelperText>
                            </Index.Box>
                          </Index.Box>
                        </Index.Box>
                        <Index.Box>
                          <Index.Typography
                            variant="label"
                            component="label"
                            className="game-title"
                          >
                            Description
                          </Index.Typography>

                          <Index.Box className="form-group">
                            <PagesIndex.CKEditor
                     
                              editor={PagesIndex.ClassicEditor}
                              data={values?.description}
                              name="description"
                              onChange={(event, editor) => {
                                const data = editor.getData();
                                setFieldValue("description", data);
                              
                              }}
                            />
                            <Index.FormHelperText error className="error-text">
                              {errors.description && touched.description
                                ? errors.description
                                : null}
                            </Index.FormHelperText>
                          </Index.Box>
                        </Index.Box>
                      </Index.Box>
                    </Index.Box>
                  </Index.Box>
                </Index.Box>
                <Index.Box className="add-game-btn-sec">
                  <Index.PrimaryButton
                    btnLabel={"Update lock period"}
                    className="primary-btn add-game-btn"
                    type="submit"
                  />
                </Index.Box>
              </Index.Box>
            )}
          </PagesIndex.Formik>
        </Index.Box>
               )}
      </Index.Box>
    </>
  );
}

export default EditLockPeriod;
